// eslint-disable-next-line
/* eslint-disable */

import { apiBot } from './config'

export default {
    telegram: {
        audioError(local, username) { //ok
            var obj = {
                    local: local,
                    username: username,
                }
                //return api.post('/apoio/retornarPacienteAFila',obj)  
            return apiBot.post('/audioError', obj)
        },

    }
}